/* eslint-disable max-len, react/jsx-props-no-spreading, react/prop-types, react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let ProductOverviewImport;
let KeyFeaturesImport;
let ItemRelatedGroupsImport;
let MajorApplianceBuyBoxImport;
let WhatWeOfferImport;
let DeliveryAndInstallationImport;
let TextAnExpertImport;
let AugmentedRealityImport;
let MagicApronBotPromptImport;

/** *********************
 * Augmented Reality
 ********************** */
export const AugmentedRealityLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "augmented-reality" */
  '@thd-olt-component-react/augmented-reality')
  .then((module) => {
    const { AugmentedReality } = module;

    AugmentedRealityImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
          <AugmentedReality {...props} />
        </QueryProvider>
      );
    };
  });

export const AugmentedReality = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality')).AugmentedReality
  : (props) => <AugmentedRealityImport {...props} />;

export const AugmentedRealityModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality')).AugmentedReality.dataModel
  : {};

/** *********************
* MA BuyBox
********************** */
export const MajorApplianceBuyBoxLoad = () => import(
  /*  webpackChunkName: "buybox" */
  '@thd-olt-component-react/buybox')
  .then((module) => {
    const { MajorApplianceBuyBox } = module;
    MajorApplianceBuyBoxImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="buybox">
          <MajorApplianceBuyBox {...props} />
        </QueryProvider>
      );
    };
  });

export const MajorApplianceBuyBox = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/buybox')).MajorApplianceBuyBox
  : (props) => <MajorApplianceBuyBoxImport {...props} />;

export const MajorApplianceBuyBoxModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/buybox')).MajorApplianceBuyBox.dataModel
  : {}

/** *********************
* What We Offer
********************** */
export const WhatWeOfferLoad = () => import(
  /*  webpackChunkName: "what-we-offer" */
  '@thd-olt-component-react/what-we-offer')
  .then((module) => {
    const { WhatWeOffer } = module;
    WhatWeOfferImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="what-we-offer">
          <WhatWeOffer {...props} />
        </QueryProvider>
      );
    };
  });

export const WhatWeOffer = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/what-we-offer')).WhatWeOffer
  : (props) => <WhatWeOfferImport {...props} />;

export const WhatWeOfferModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/what-we-offer')).WhatWeOffer.dataModel
  : {}

/** *********************
 * Text An Expert
 ********************** */
export const TextAnExpertLoad = () => import(
  /*  webpackChunkName: "text-an-expert" */
  '@thd-olt-component-react/text-an-expert')
  .then((module) => {
    const { TextAnExpert } = module;
    TextAnExpertImport = (props) => {
      return (
        <TextAnExpert {...props} />
      );
    };
  });

export const TextAnExpert = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/text-an-expert')).TextAnExpert
  : (props) => <TextAnExpertImport {...props} />;

export const TextAnExpertModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/text-an-expert')).TextAnExpert.dataModel
  : {}

/** *********************
* Delivery And Installation
********************** */
export const DeliveryAndInstallationLoad = () => import(
  /*  webpackChunkName: "delivery-and-installation" */
  '@thd-olt-component-react/delivery-and-installation')
  .then((module) => {
    const { DeliveryAndInstallation } = module;
    DeliveryAndInstallationImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="delivery-and-installation">
          <DeliveryAndInstallation {...props} />
        </QueryProvider>
      );
    };
  });

export const DeliveryAndInstallation = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/delivery-and-installation')).DeliveryAndInstallation
  : (props) => <DeliveryAndInstallationImport {...props} />;

export const DeliveryAndInstallationModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/delivery-and-installation')).DeliveryAndInstallation.dataModel
  : {}

/** *********************
* Magic Apron
********************** */
export const MagicApronBotPromptLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "questions-and-answers" */
  '@thd-olt-component-react/magic-apron')
  .then((module) => {
    const { BotPrompt } = module;

    MagicApronBotPromptImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="magic-apron-qa-bot">
          <BotPrompt {...props} />
        </QueryProvider>
      );
    };
  });

export const MagicApronBotPrompt = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron')).BotPrompt
  : (props) => <MagicApronBotPromptImport {...props} />;

export const MagicApronBotPromptModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron')).BotPrompt.dataModel
  : {};
